module.exports = __webpack_public_path__ + "assets/img/pay-success.0a7e42e2.png";